export const normalType = {
  rules: [
    {
      id: 1,
      name: "手机号格式判断",
      val: /^[1][3,4,5,6,7,8,9][0-9]{9}$/,
      msg: "手机号格式判断错误"
    }
  ]
}
export const numberCardType = {
  rules: [
    {
      id: 1,
      name: '中国居民身份证',
      val: /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/,
      msg: '中国居民身份证格式判断错误'
    },
    {
      id: 2,
      name: '香港特区护照/身份证明',
      val: /^([A-Z]\d{6,10}(\(\w{1}\))?)$/,
      msg: '香港特区护照/身份证明格式判断错误'
    },
    {
      id: 3,
      name: '澳门特区护照/身份证明',
      val: /^([A-Z]\d{6,10}(\(\w{1}\))?)$/,
      msg: '澳门特区护照/身份证明格式判断错误'
    },
    {
      id: 4,
      name: '台湾居民来往大陆通行证',
      val: /^\d{8}|^[a-zA-Z0-9]{10}|^\d{18}$/,
      msg: '台湾居民来往大陆通行证格式判断错误'
    }
  ]
}
